import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DropdownSelect from "components/DropdownSelect";
import LoadingButton from "components/LoadingButton";
import TranslatableTextField from "components/TranslatableTextField";
import { useLanguage } from "contexts/language.context";
import * as React from "react";

export default function TerritoriesDialog({ isOpen, onSubmit, data, type }) {
  const { label } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [territory, setTerritory] = React.useState({
    name: { en: "" },
    countryId: null,
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    setTerritory({
      name: { en: "" },
      countryId: null,
    });
  }, [isOpen]);

  React.useEffect(() => {
    setTerritory({
      ...data.territory,
      name: data?.territory?.allLanguageName || { en: "" },
    });
  }, [data.territory]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit(territory);
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit" ? label("edit-territory") : label("create-territory")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 1.5 }}>
          <Grid item xs={12}>
            <TranslatableTextField
              autoFocus
              required
              id="name"
              name="name"
              label={label("name-singular")}
              type="text"
              values={territory.name}
              onChange={(e) => {
                setTerritory({
                  ...territory,
                  name: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <DropdownSelect
              id="country-select"
              required
              label={label("country-singular")}
              initialValue={territory?.countryId || ""}
              onChange={(newValue) => {
                setTerritory({ ...territory, countryId: newValue?.id || null });
              }}
              items={
                data?.countries?.map((c) => ({ id: c.id, label: c.name })) || []
              }
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
